import React, { useState } from 'react';
import { Container } from '@/ui';
import { InvestorsTableBox } from '@/components';
import { INVESTOR_STATUS_TABS, LEGAL_STATUS_TABS } from '@/utils/static';
import { useTranslation } from 'react-i18next';
import { Select, Tabs } from 'antd';
import { Title } from '@/ui/typography';

const TITLES = {
  PERSONAL: 'Individuals clients',
  COMPANY: 'Legal entities'
};
const TABS = {
  PERSONAL: INVESTOR_STATUS_TABS,
  COMPANY: LEGAL_STATUS_TABS
};
export const InvestorsView = ({ investors, fetchInvestors, INVESTORS_ON_PAGE, type }) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const onChangeSelectedTab = (value) => {
    setSelectedTab(value);
  };
  const tabsList = TABS[type] || INVESTOR_STATUS_TABS;
  return (
    <Container $paddingBottom={48}>
      <Title $paddingCss={'24px 0'} level={3}>
        {t(TITLES[type]) || t('Investors')}
      </Title>

      <Container $mdHidden>
        <Tabs
          items={tabsList?.map((item, index) => {
            return { key: index, label: t(item) };
          })}
          activeKey={selectedTab}
          onChange={setSelectedTab}
        />
      </Container>

      <Container $hidden $mdVisible $marginBottom={15}>
        <Select
          defaultValue={selectedTab}
          style={{ width: 200 }}
          options={tabsList?.map((item, index) => ({ value: index, label: t(item) }))}
          onChange={onChangeSelectedTab}
        />
      </Container>

      <InvestorsTableBox
        investors={investors}
        updateSearchParams={fetchInvestors}
        INVESTORS_ON_PAGE={INVESTORS_ON_PAGE}
        selectedTab={selectedTab}
      />
    </Container>
  );
};
